import Vue from "vue";

export function httpGetInvitationInfo(data) {
  return Vue.$axios({
    url: "/api/user/invitation/info",
    method: "post",
    data,
  });
}

export function httpGetTeam(data) {
  return Vue.$axios({
    url: "/api/log/mySubordinate",
    method: "post",
    data,
  });
}

export function httpApplyTrueName(data) {
  return Vue.$axios({
    url: "/api/home/applyTrueName",
    method: "post",
    data,
  });
}

export function httpUpload(data) {
  return Vue.$axios({
    url: "/api/user/upload/one",
    method: "post",
    data,
  });
}

export function httpAddAuth(data) {
  return Vue.$axios({
    url: "/api/user/user_auth/addauth",
    method: "post",
    data,
  });
}

export function httpSetPayPassword(data) {
  return Vue.$axios({
    url: "/api/user/pay_pwd/addpwd",
    method: "post",
    data,
  });
}

export function httpEditPayPassword(data) {
  return Vue.$axios({
    url: "/api/user/pay_pwd/uppwd",
    method: "post",
    data,
  });
}

export function httpCheckPayPassword(data) {
  return Vue.$axios({
    url: "/api/user/pay_pwd/oldpwdva",
    method: "post",
    data,
  });
}

export function httpConfirmCheck(data) {
  return Vue.$axios({
    url: "/api/user/Checks/confirmCheck",
    method: "post",
    data,
  });
}

export function httpCheckMesCode(data) {
  return Vue.$axios({
    url: "/api/user/Checks/VcodeCheck",
    method: "post",
    data,
  });
}

export function httpSetNewPayPassword(data) {
  return Vue.$axios({
    url: "/api/user/pay_pwd/forgetpwd",
    method: "post",
    data,
  });
}

export function httpOpenGoogleCheck(data) {
  return Vue.$axios({
    url: "/api/user/Checks/opencheck",
    method: "post",
    data,
  });
}

export function httpCloseGoogleCheck(data) {
  return Vue.$axios({
    url: "/api/user/Checks/closecheck",
    method: "post",
    data,
  });
}

export function httpGoogleCheck(data) {
  return Vue.$axios({
    url: "/api/user/Checks/checkcode",
    method: "post",
    data,
  });
}
// 获取认证等级列表
export function httpGetSecList(data) {
  return Vue.$axios({
    url: "/api/user/user_auth/getAuthGrade",
    method: "post",
    data,
  });
}

export function httpGetKSToken(data) {
  return Vue.$axios({
    url: "/api/user/user_auth/kSVideoAuth",
    method: "post",
    data,
  });
}

export function httpGetCode(data) {
  return Vue.$axios({
    url: "/api/user/verification_code/send",
    method: "post",
    data,
  });
}

export function httpBindEmail(data) {
  return Vue.$axios({
    url: "/api/user/profile/bindingEmail",
    method: "post",
    data,
  });
}

export function httpBindMobile(data) {
  return Vue.$axios({
    url: "/api/user/profile/bindingMobile",
    method: "post",
    data,
  });
}
